import moment from "moment-timezone";


export const utcToLocal = (utcString) => {
    return moment.utc(utcString).local().format("hh:mm a");
};
